(() => {
  const packSize = 12;
  document.querySelectorAll('[data-builder]').forEach(builder => {
    const rows = [...builder.querySelectorAll('.bundle-row')];
    const counts = rows.map(() => 0);
    const selections = new Map();
    const add = builder.querySelector('[data-pack-add]');
    const status = builder.querySelector('[data-status]');
    let busy = false;
    const total = () => [...selections.values()].reduce((sum, item) => sum + item.quantity, 0);
    function paint() {
      const count = total();
      builder.querySelector('[data-count]').textContent = `${count} / ${packSize}`;
      builder.querySelector('[data-progress]').value = count;
      rows.forEach((row, index) => {
        row.querySelector('[data-quantity]').textContent = counts[index];
        row.querySelector('[data-minus]').disabled = counts[index] === 0 || busy;
        row.querySelector('[data-plus]').disabled = count >= packSize || busy || !row.querySelector('[data-choice]').options.length;
        row.querySelector('[data-choice]').disabled = counts[index] > 0 || busy;
      });
      add.disabled = count !== packSize || builder.dataset.ready !== 'true' || busy;
      builder.querySelector('[data-reset]').disabled = busy;
      status.textContent = count === packSize ? 'Your 12-pack is full. A whole lot of flavor!' : `Choose ${packSize - count} more ${packSize - count === 1 ? 'jar' : 'jars'} to fill your pack.`;
    }
    rows.forEach((row, index) => {
      function change(delta) {
        if (busy || (delta > 0 && total() >= packSize) || (delta < 0 && counts[index] === 0)) return;
        const option = row.querySelector('[data-choice]').selectedOptions[0];
        if (!option) return;
        const key = index + ':' + option.value;
        counts[index] += delta;
        selections.set(key, { name: option.dataset.name || option.textContent, quantity: counts[index] });
        if (!counts[index]) selections.delete(key);
        paint();
      }
      row.querySelector('[data-plus]').addEventListener('click', () => change(1));
      row.querySelector('[data-minus]').addEventListener('click', () => change(-1));
    });
    builder.querySelector('[data-reset]').addEventListener('click', () => { selections.clear(); counts.fill(0); paint(); });
    add.addEventListener('click', async () => {
      if (total() !== packSize || builder.dataset.ready !== 'true' || busy) return;
      busy = true; paint(); status.textContent = 'Adding your 12-pack…';
      const properties = { '_Johnny9 count': '12' };
      [...selections.values()].forEach((item,index) => { properties[`Flavor ${index + 1}`] = `${item.quantity} × ${item.name}`; });
      try {
        const response = await fetch(builder.dataset.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: builder.dataset.variant, quantity: 1, properties }] }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Your pack could not be added. Please try again.');
        window.location.assign(builder.dataset.root + 'cart');
      } catch (error) { busy = false; paint(); status.textContent = error.message || 'Connection error. Please try again.'; }
    });
    paint();
  });
  document.querySelectorAll('[data-product-variant]').forEach(select => {
    const button = select.closest('form').querySelector('[data-product-add]');
    function update() { const available = select.selectedOptions[0]?.dataset.available === 'true'; button.disabled = !available; button.textContent = available ? 'Add to cart' : 'Sold out'; }
    select.addEventListener('change', update); update();
  });
})();
